<template>
    <header v-if="$route.name != 'game' && $route.name != 'customise' && $route.name !='instructions' && $route.name !='ready' && $route.name !='complete' ">
        <nav>
            <router-link :to="show_link ? '/' : '#'">
                <img class="logo" src="../../public/assets/rs-logo.png" alt="RS Components">
            </router-link>
            <div class="expand">
                <div></div>
                <div></div>
            </div>
            <!-- <div class="burger">
                <div></div>
                <div></div>
                <div></div>
            </div> -->
        </nav>
        <div class="menu">
            <ul>
                <li>Home</li>
                <li>Competition</li>
                <li>About</li>
                <li>RS Components</li>
                <li>Legal</li>
            </ul>
        </div>
    </header>
</template>

<script>
        export default {
        name: 'AppSiteFooter',
        components: {
        },
        data() {
            return {
                show_link: ''
            }
        },
        methods: {
        },
        mounted() {
            this.$route.name === 'home'? this.show_link = true : this.show_link = false;
            this.$route.name === 'register'? this.show_link = true : this.show_link = false;
        },
        beforeMount(){
        }
    };
</script>